// Helpers para manipulação de autenticação no localStorage
import { PessoaDTO } from "@/types/pessoa";

export const AUTH_USER_KEY = "pessoa";
export const AUTH_SESSION_KEY = "auth_session_id";
export const POST_LOGIN_REDIRECT_KEY = "post_login_redirect";

export function startStoredSession(accessToken: string, refreshToken: string): void {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  const sessionId = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  localStorage.setItem(AUTH_SESSION_KEY, sessionId);
  localStorage.setItem("access_token", accessToken);
  localStorage.setItem("refresh_token", refreshToken);
}

export function getStoredUser(): PessoaDTO | null {
  const stored = localStorage.getItem(AUTH_USER_KEY);
  return stored ? JSON.parse(stored) : null;
}

export function setStoredUser(user: PessoaDTO): void {
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
}

export function removeStoredUser(): void {
  localStorage.removeItem(AUTH_USER_KEY);
}
